/* ------------------------------------------------------------------
   SEND A HINT
   Builds a shareable link to this product carrying the chosen variant,
   the engraving and an optional note. Uses the native share sheet on
   mobile, copy on desktop.

   The engraving can come from either direction: one she already confirmed
   in the engraving modal, or one she types straight into this sheet. The
   typed one never touches the cart or the session store, because sending a
   hint is not buying.

   We capture the sender's email only and fire a Klaviyo "Sent a Hint"
   event. The recipient's address is never collected, so there is no
   consent exposure.

   On arrival, renders a band above the buy area telling the recipient
   who sent it and what was picked. Liquid cannot read query strings,
   so the band is drawn here.
------------------------------------------------------------------ */
(function () {
  var root = document.querySelector('[data-hint]');

  /* ---------- reading the current selection ---------- */

  function currentVariantId() {
    var u = new URLSearchParams(location.search).get('variant');
    if (u) return u;
    var input = document.querySelector('product-form input[name="id"], form[action*="/cart/add"] input[name="id"]');
    return input ? input.value : '';
  }

  function currentVariantLabel() {
    var picked = document.querySelectorAll('.variant-picker input:checked, variant-picker input:checked');
    var parts = [];
    [].forEach.call(picked, function (i) {
      var l = i.closest('label') || document.querySelector('label[for="' + i.id + '"]');
      if (l && l.textContent.trim()) parts.push(l.textContent.trim());
    });
    return parts.join(', ');
  }

  /* An engraving she already confirmed in the engraving modal. */
  function savedEngraving() {
    if (!root) return null;
    try {
      var raw = sessionStorage.getItem('boobie-engraving-' + root.dataset.productId);
      if (!raw) return null;
      var s = JSON.parse(raw);
      return (s && s.confirmed && s.text) ? { text: s.text, font: s.font } : null;
    } catch (e) { return null; }
  }

  /* One she is typing straight into this sheet. Sending a hint to someone else
     is not the same as buying, so this never touches the cart or the session
     store: it rides along in the link and nowhere else. */
  function typedEngraving() {
    if (!root) return null;
    var el = root.querySelector('[data-hint-eng-text]');
    var text = el ? (el.value || '').trim() : '';
    if (!text) return null;
    var on = root.querySelector('[data-hint-fonts] button[aria-pressed="true"]');
    return { text: text, font: on ? on.dataset.font : '' };
  }

  function engraving() { return savedEngraving() || typedEngraving(); }

  /* ---------- building the link ---------- */

  function senderName() {
    var el = root && root.querySelector('[data-hint-name]');
    return el ? (el.value || '').trim() : '';
  }

  function buildLink(note) {
    /* Stay on the visitor's own market domain. shop.url always returns the
       primary domain (.com), which would send an AU shopper's hint to the US
       storefront and 404 on AU-only products. */
    var path = (root && root.dataset.productPath) || location.pathname;
    var base = location.origin + path;
    var p = [];
    var v = currentVariantId();
    if (v) p.push('variant=' + encodeURIComponent(v));
    var e = engraving();
    if (e) {
      p.push('eng=' + encodeURIComponent(e.text));
      if (e.font) p.push('font=' + encodeURIComponent(e.font));
    }
    var who = senderName();
    if (who) p.push('from=' + encodeURIComponent(who));
    if (note) p.push('note=' + encodeURIComponent(note));
    p.push('hint=1');
    return base.split('?')[0] + (p.length ? '?' + p.join('&') : '');
  }

  /* ---------- Klaviyo: sender only ---------- */

  function trackHint(email, link) {
    try {
      var e = engraving();
      var payload = {
        Product: (document.querySelector('.pdp-title') || {}).textContent || document.title,
        Variant: currentVariantLabel(),
        Engraved: !!e,
        Link: link,
        SenderName: senderName()
      };
      if (window.klaviyo && typeof window.klaviyo.push === 'function') {
        window.klaviyo.push(['identify', { '$email': email, '$first_name': senderName() }]);
        window.klaviyo.push(['track', 'Sent a Hint', payload]);
      } else {
        (window._learnq = window._learnq || []).push(['identify', { '$email': email }]);
        window._learnq.push(['track', 'Sent a Hint', payload]);
      }
    } catch (err) { /* never block the share on tracking */ }
  }

  /* ---------- the sheet ---------- */

  if (root) {
    var sheet  = root.querySelector('[data-hint-sheet]');
    var openEl = root.querySelector('[data-hint-open]');
    var said   = root.querySelector('[data-hint-said]');
    var emailEl= root.querySelector('[data-hint-email]');
    var errEl  = root.querySelector('[data-hint-err]');
    var noteEl = root.querySelector('[data-hint-note]');
    var lastFocus = null;

    function refreshSummary() {
      var spec = root.querySelector('[data-hint-spec]');
      var eng  = root.querySelector('[data-hint-eng]');
      if (spec) spec.textContent = currentVariantLabel();
      var e = engraving();
      if (eng) {
        if (e) { eng.textContent = 'Engraved "' + e.text + '"' + (e.font ? ' - ' + e.font : ''); eng.hidden = false; }
        else { eng.hidden = true; }
      }
      /* Never promise an engraving she has not chosen. */
      var sub = root.querySelector('[data-hint-sub]');
      if (sub) {
        sub.textContent = e
          ? 'Your finish, size and engraving all go with it.'
          : 'Your finish and size go with it.';
      }
      /* Let her add the engraving right here, but only where the product
         offers it and only when she has not already set one in the modal. */
      var add = root.querySelector('[data-hint-eng-add]');
      if (add) add.hidden = !!savedEngraving() || !document.querySelector('.pdp-personalise');
    }

    /* Distinct font options, by name.

       Changing a variant re-renders the section and leaves a second copy of
       the engraving modal in the page, so [data-ce-font] started returning
       four buttons and the picker read "Classic Script Classic Script". Both
       copies are hidden and neither sits inside <custom-engraving>, so there
       is no reliable way to tell which one is live. The names are identical
       either way, so dedupe on those and ignore the duplicate markup. */
    function fontOptions() {
      var seen = {}, list = [];
      [].forEach.call(document.querySelectorAll('[data-ce-font]'), function (o) {
        var name = o.dataset.ceFont;
        if (name && !seen[name]) { seen[name] = true; list.push(o); }
      });
      return list;
    }

    /* Rebuilt on every open rather than once, so a re-render can never leave
       a stale picker behind. Whatever she had selected is carried over. */
    function buildFonts() {
      var wrap = root.querySelector('[data-hint-fonts]');
      var textEl = root.querySelector('[data-hint-eng-text]');
      if (!wrap) return;

      var opts = fontOptions();
      if (!opts.length) { wrap.innerHTML = ''; wrap.hidden = true; return; }

      var prev = wrap.querySelector('button[aria-pressed="true"]');
      var chosen = prev ? prev.dataset.font : null;
      wrap.innerHTML = '';

      opts.forEach(function (o, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.textContent = o.textContent.trim();
        b.dataset.font = o.dataset.ceFont;
        b.className = o.className.replace(/\bce__opt\b/g, '').trim();
        var on = chosen ? (o.dataset.ceFont === chosen) : (i === 0);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        b.addEventListener('click', function () {
          [].forEach.call(wrap.children, function (c) { c.setAttribute('aria-pressed', 'false'); });
          b.setAttribute('aria-pressed', 'true');
        });
        wrap.appendChild(b);
      });

      var src = document.querySelector('[data-ce-text]');
      if (textEl && src && src.maxLength > 0) textEl.maxLength = src.maxLength;
      /* The font only matters once there is something to set in it, and
         holding it back keeps the send button above the fold on a phone. */
      wrap.hidden = !(textEl && textEl.value.trim());
      bindEngravingInput(textEl);
    }

    /* Bound once, however many times the picker is rebuilt. */
    var engravingInputBound = false;
    function bindEngravingInput(textEl) {
      if (engravingInputBound || !textEl) return;
      engravingInputBound = true;
      textEl.addEventListener('input', function () {
        var w = root.querySelector('[data-hint-fonts]');
        if (w) w.hidden = !textEl.value.trim();
        var sub = root.querySelector('[data-hint-sub]');
        if (!sub) return;
        /* Keep the promise honest while she types. */
        sub.textContent = engraving()
          ? 'Your finish, size and engraving all go with it.'
          : 'Your finish and size go with it.';
      });
    }

    function open() {
      lastFocus = document.activeElement;
      buildFonts();
      refreshSummary();
      sheet.hidden = false;
      document.body.style.overflow = 'hidden';
      if (emailEl) emailEl.focus();
    }
    var closeTimer = null;
    var doneCleanup = null;

    function close() {
      sheet.hidden = true;
      document.body.style.overflow = '';
      if (said) said.textContent = '';
      if (errEl) errEl.hidden = true;
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
      if (doneCleanup) { doneCleanup(); doneCleanup = null; }
      /* back to the form, ready for next time */
      var body = root.querySelector('[data-hint-body]');
      var done = root.querySelector('[data-hint-done]');
      if (body) body.hidden = false;
      if (done) done.hidden = true;
      if (lastFocus) lastFocus.focus();
    }

    /* Swap the whole panel for a confirmation, then close. The old inline
       note sat at the bottom of a scrolling panel and was easy to miss.

       The countdown only runs while she is actually looking at the page. The
       share sheet hands control straight to WhatsApp or Messages, so a plain
       timer would burn down while she was still typing her message and she
       would come back to a closed sheet, never having seen it. */
    function showDone(title, sub) {
      var body = root.querySelector('[data-hint-body]');
      var done = root.querySelector('[data-hint-done]');
      if (!body || !done) { close(); return; }
      root.querySelector('[data-hint-done-title]').textContent = title;
      root.querySelector('[data-hint-done-sub]').textContent = sub;
      body.hidden = true;
      done.hidden = false;

      function countdown() {
        if (closeTimer) clearTimeout(closeTimer);
        closeTimer = setTimeout(close, 2200);
      }
      function onVisible() {
        if (document.hidden) {
          /* she has left for the share target: hold the confirmation */
          if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
        } else {
          countdown();
        }
      }
      document.addEventListener('visibilitychange', onVisible);
      doneCleanup = function () {
        document.removeEventListener('visibilitychange', onVisible);
      };
      if (!document.hidden) countdown();
    }

    openEl.addEventListener('click', open);

    root.querySelector('[data-hint-close]').addEventListener('click', close);
    sheet.addEventListener('click', function (ev) { if (ev.target === sheet) close(); });
    document.addEventListener('keydown', function (ev) {
      if (ev.key === 'Escape' && !sheet.hidden) close();
    });

    function validEmail(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v); }

    function proceed(mode) {
      var email = (emailEl.value || '').trim();
      if (!validEmail(email)) { errEl.hidden = false; emailEl.focus(); return; }
      errEl.hidden = true;

      var note = (noteEl.value || '').trim();
      var link = buildLink(note);
      trackHint(email, link);

      if (mode === 'share' && navigator.share) {
        navigator.share({ title: document.title, text: note || 'Have a look at this one.', url: link })
          .then(function () { showDone('Sent', 'Hope they take the hint.'); })
          .catch(function () { /* user dismissed the share sheet, leave the form up */ });
        return;
      }
      copy(link);
    }

    function copy(link) {
      var done = function () { showDone('Link copied', 'Paste it into any chat.'); };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(link).then(done, function () { fallback(link, done); });
      } else { fallback(link, done); }
    }
    function fallback(link, done) {
      var t = document.createElement('textarea');
      t.value = link; t.style.position = 'fixed'; t.style.opacity = '0';
      document.body.appendChild(t); t.select();
      try { document.execCommand('copy'); done(); }
      catch (e) { said.textContent = 'Could not copy. Long-press the link to copy it.'; }
      document.body.removeChild(t);
    }

    root.querySelector('[data-hint-send]').addEventListener('click', function () { proceed('share'); });
    root.querySelector('[data-hint-copy]').addEventListener('click', function () { proceed('copy'); });
  }

  /* ---------- arriving on a hint ---------- */

  function renderBand() {
    var q = new URLSearchParams(location.search);
    if (!q.get('hint')) return;

    var from = (q.get('from') || '').trim();
    var eng  = (q.get('eng')  || '').trim();
    var note = (q.get('note') || '').trim();

    var anchor = document.querySelector('.pdp-eyebrow') ||
                 document.querySelector('.pdp-title') ||
                 document.querySelector('.product-info');
    if (!anchor || document.querySelector('.hint-band')) return;

    var band = document.createElement('div');
    band.className = 'hint-band';
    /* Band wording. Swap WHO/SUB for one of the alternates in the comment
       below if you prefer a different tone. */
    var who = from ? ('A little hint from ' + from + '.') : 'A little hint, just for you.';
    var sub = eng
      ? 'Her size and engraving are already set, so there is nothing for you to guess.'
      : 'Her finish and size are already set, so there is nothing for you to guess.';
    /* alternates for who:
         "<name> has her eye on this one."
         "<name> picked this one out."
         "<name> chose this one."
       alternates for sub:
         "Set up exactly the way she chose it."
         "Her finish, size and engraving are already chosen."             */
    var html = '<div class="hint-band__txt"><span class="hint-band__who"></span>' +
               '<span class="hint-band__spec"></span>';
    if (eng)  html += '<span class="hint-band__eng"></span>';
    if (note) html += '<span class="hint-band__note"></span>';
    html += '</div>';
    band.innerHTML = html;
    band.querySelector('.hint-band__who').textContent = who;
    band.querySelector('.hint-band__spec').textContent = sub;
    if (eng)  band.querySelector('.hint-band__eng').textContent  = 'Engraved "' + eng + '"';
    if (note) band.querySelector('.hint-band__note').textContent = '"' + note + '"';

    anchor.parentNode.insertBefore(band, anchor);

    /* The band told him her engraving, but the engraving tool only restores
       from its own session store, so adding to bag here would have produced a
       plain bracelet. Fill the modal in from the link instead. He still ticks
       the verification himself: customised bracelets cannot be returned, so
       that has to stay his own confirmation, not ours. */
    var personalise = document.querySelector('.pdp-personalise');
    if (!eng || !personalise) return;

    var apply = document.createElement('button');
    apply.type = 'button';
    apply.className = 'hint-band__apply';
    apply.textContent = 'Add this engraving';
    band.querySelector('.hint-band__txt').appendChild(apply);

    apply.addEventListener('click', function () {
      personalise.click();
      setTimeout(function () {
        /* A variant change can leave a second, stale copy of the engraving
           modal in the page, and querying the document would fill that one in
           while she looks at the other. Only one is ever visible, so work
           inside whichever modal actually opened. */
        var modal = document.querySelector('.ce-modal:not([hidden])') || document;
        var font = (new URLSearchParams(location.search).get('font') || '').trim();
        if (font) {
          var fb = modal.querySelector('[data-ce-font="' + font.replace(/"/g, '') + '"]');
          if (fb) fb.click();
        }
        var textEl = modal.querySelector('[data-ce-text]');
        if (textEl) {
          textEl.value = eng;
          textEl.dispatchEvent(new Event('input', { bubbles: true }));
        }
      }, 140);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', renderBand);
  } else { renderBand(); }
})();
